// const Diff = require('diff');
import { diffWordsWithSpace } from "diff";

// Type declarations for Office.js
/// <reference types="office-js" />

// Helper function to concatenate file slices
function concatenateSlices(slices: (ArrayBuffer | Uint8Array)[]): Uint8Array {
  // Filter out any null/undefined values and handle both ArrayBuffer and Uint8Array
  const validSlices = slices.filter((slice) => {
    if (!slice) return false;

    const length =
      slice instanceof ArrayBuffer ? slice.byteLength : slice.length;
    const isValid = length !== undefined && length >= 0;
    return isValid;
  });

  let totalLength = validSlices.reduce((sum, slice) => {
    const length =
      slice instanceof ArrayBuffer ? slice.byteLength : slice.length;
    return sum + length;
  }, 0);

  let result = new Uint8Array(totalLength);
  let offset = 0;

  validSlices.forEach((slice) => {
    const bufferArray =
      slice instanceof ArrayBuffer ? new Uint8Array(slice) : slice;

    // Double-check bounds before setting
    if (offset + bufferArray.length <= result.length) {
      result.set(bufferArray, offset);
      offset += bufferArray.length;
    } else {
      throw new Error(`Slice concatenation would exceed array bounds`);
    }
  });

  return result;
}

function countOccurrences(string, subString) {
  // Escape special characters in the subString to avoid regex interpretation
  const escapedSubString = subString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  // Create a regular expression with the escaped subString and the global flag
  const regex = new RegExp(escapedSubString, "g");
  // Use match() to find all occurrences of the subString in the string
  const matches = string.match(regex);
  // Return the number of matches found
  return matches ? matches.length : 0;
}

export const CqWord = {
  addContentControl: (key: string, value: string, name: string) => {
    Word.run((context) => {
      let serviceNameRange = context.document.getSelection();
      let serviceNameContentControl = serviceNameRange.insertContentControl();

      serviceNameContentControl.tag = `meta_${key}`;
      serviceNameContentControl.title = name;
      serviceNameContentControl.cannotEdit = false;
      serviceNameContentControl.insertText(value, "Replace");
      return context.sync();
    })
      .then(() => {
        // fillAllMetas(`meta_${key}`, value)
      })
      .catch((err) => {
        console.error("Error: ", JSON.stringify(err));
      });
  },

  addHtmlText: (
    text: string,
    type?: "After" | "Before" | "End" | "Replace" | "Start"
  ) => {
    Word.run(async (context) => {
      let selectionRange = context.document.getSelection();
      selectionRange.getRange("Start");

      selectionRange.load("font");
      await context.sync();

      const fontFamily = selectionRange.font.name;

      let processedText = text;

      if (fontFamily) {
        processedText = `<span style="font-family: ${fontFamily};">${processedText}</span>`;
      }

      selectionRange.insertHtml(processedText, type ? type : "Replace");
      await context.sync();
    });
  },

  diffsSelectedText: async (newText) => {
    // TODO: Refactor this function to handle text diffs more efficiently
    await Word.run(async (context) => {
      const paragraph: Word.Range = context.document.getSelection();
      const sentencesWord = paragraph.split([".", "!", "?"], false, false);
      sentencesWord.load("text");

      await context.sync();

      if (!newText) return;

      // Prechadzanie kazdej starej vety : Word
      const runRedling = async () => {
        for (let index = 0; index < sentencesWord.items.length; index++) {
          const oldSentence = sentencesWord.items[index].text;
          const newSentence = newText.match(/[^.!?]+[.!?]/g)[index];
          await context.sync();

          let diff = [];
          if (oldSentence && newSentence) {
            diff = diffWordsWithSpace(oldSentence, newSentence);
          }

          // TODO: 1. Ak cela veta sa vymazala tak ju treba vymazat
          if (diff.length === 0) {
            sentencesWord.items[index].insertText("", "Replace");
            await context.sync();
          }

          // Prechadzanie kazdej zmeny
          for (let i = 0; i < diff.length; i++) {
            // ak je odstranene slovo, tak pozriet na dalsiu zmenu a nahradit to tym
            if (diff[i].removed == true) {
              if (diff[i].value == " ") {
                continue;
              }

              const find: Word.RangeCollection = sentencesWord.items[
                index
              ].search(diff[i].value);
              find.load("text");
              await context.sync();
              if (find.items.length > 1) {
                const sum = diff.reduce((accu, current, reduceIndex) => {
                  const pattern = new RegExp(
                    "\\b" + diff[i].value + "\\b",
                    "i"
                  );
                  const isWordIncluded = pattern.test(current.value);

                  if (reduceIndex <= i && isWordIncluded) {
                    if (current.removed == true && reduceIndex < i) {
                    } else {
                      const occurrences = countOccurrences(
                        current.value,
                        diff[i].value
                      );
                      accu = accu + occurrences; // Increment the accumulator if the condition is met
                    }
                  }
                  return accu; // Always return the accumulator from the callback
                }, 0); // Initial accumulator value set to 0

                if (sum == 0) {
                  // If empty space
                  if (find.items[0].text === " ") {
                    find.items[sum].insertText("", "Replace");
                  }
                  await context.sync();
                } else {
                  // if next part has added then add this
                  if (diff[i + 1] != null && diff[i + 1].added == true) {
                    find.items[sum - 1].insertText(
                      diff[i + 1].value,
                      "Replace"
                    );
                    // if next part is empty space and then is added
                  } else {
                    find.items[sum - 1].insertText("", "Replace");
                  }
                  await context.sync();
                }
              } else if (find.items.length <= 1 && find.items.length >= 0) {
                // if next part has added then add this

                if (diff[i + 1] != null && diff[i + 1].added == true) {
                  find.items[0].insertText(diff[i + 1].value, "Replace");
                } else {
                  find.items[0].insertText(" ", "Replace");
                }
                await context.sync();
              }
            }

            // Ak je pridane slovo
            if (diff[i].added == true) {
              // Zatial medzery vynechavame
              if (diff[i].value == " ") {
                continue;
              }

              if (i == 0) {
                sentencesWord.items[index].insertText(diff[i].value, "Start");
                await context.sync();
              }
              // a predchadzajuce slovo/slova su povodne
              else if (
                diff[i - 1].added == false &&
                diff[i - 1].removed == false
              ) {
                if (diff[i - 1].value == " " && i > 1) {
                  // Predchadzajuce slovo je medzera, a pred pred je string
                  // Predpokladame ze je zly search a treba nam spocitat kolko itemov mame
                  await context.sync();
                  const find = sentencesWord.items[index].search(
                    " " + diff[i - 2].value,
                    {
                      ignorePunct: false,
                      ignoreSpace: false,
                      matchWholeWord: false,
                    }
                  );
                  find.load("text");
                  await context.sync();

                  if (find.items.length > 1) {
                    const sum = diff.reduce((accu, current, reduceIndex) => {
                      // diff[i - 2].value is "the"
                      const pattern = new RegExp(
                        "\\b" + diff[i - 2].value + "\\b",
                        "i"
                      );
                      const isWordIncluded = pattern.test(current.value);

                      if (reduceIndex < i - 2 && isWordIncluded) {
                        if (current.removed == true) {
                        } else {
                          const occurrences = countOccurrences(
                            current.value,
                            diff[i - 2].value
                          );
                          accu = accu + occurrences; // Increment the accumulator if the condition is met
                        }

                        //}
                      }
                      return accu; // Always return the accumulator from the callback
                    }, 0); // Initial accumulator value set to 0

                    find.items[sum].insertText(" " + diff[i].value, "End");
                    await context.sync();
                  } else {
                    if (find.items.length > 0) {
                      if (diff[i - 1].value == " ") {
                        find.items[0].insertText(" " + diff[i].value, "End");
                      } else {
                        find.items[0].insertText(diff[i].value, "End");
                      }
                      await context.sync();
                    }
                  }
                } else {
                  const find_second: Word.Range = sentencesWord.items[index]
                    .search(diff[i - 1].value, {
                      ignorePunct: true,
                      ignoreSpace: true,
                      matchWholeWord: false,
                    })
                    .getFirstOrNullObject();

                  find_second.load("text");
                  await context.sync();

                  if (!find_second) {
                    const find_third: Word.Range = sentencesWord.items[index]
                      .search(diff[i - 1].value.split(" ")[0], {
                        ignorePunct: true,
                        ignoreSpace: true,
                        matchWholeWord: false,
                      })
                      .getFirstOrNullObject();

                    find_third.load("text");
                    await context.sync();
                  }
                  if (find_second) {
                    find_second.insertText(diff[i].value, "End");
                    await context.sync();
                  }
                }
              } else {
                // Predchadzajuce slovo bolo vymazane
              }
            }
          }
        }
      };

      await runRedling();

      let diff = [];

      const finalText = paragraph.load("text");
      await context.sync();

      diff = diffWordsWithSpace(finalText.text, newText);

      if (diff.length > 0) {
        for (let i = 0; i < diff.length; i++) {
          if (diff[i].added == true) {
            paragraph.insertText(diff[i].value, "End");
            await context.sync();
          }
        }
      }
    });
  },

  documentSelectionChanged: (callback: (text: string) => void) => {
    Office.context.document.addHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      () => {
        Office.context.document.getSelectedDataAsync(
          Office.CoercionType.Text,
          (result: unknown) => {
            //@ts-ignore
            callback(result.value as string);
          }
        );
      }
    );
  },

  getDocument: (callback: (text: string) => void) => {
    Word.run(async (context) => {
      const body = context.document.body;

      // Queue a command to load the text in document body.
      // https://github.com/OfficeDev/office-js-snippets/blob/prod/samples/word/50-document/manage-body.yaml
      body.load("text");

      // Synchronize the document state by executing the queued commands, and return a promise to indicate task completion.
      await context.sync();

      callback(body.text);
    });
  },

  // Get document as File object
  getDocumentAsFile: (filename: string = "document.docx"): Promise<File> => {
    return new Promise((resolve, reject) => {
      try {
        const documentUrl = Office.context.document.url || "";
        const isPDF = documentUrl.toLowerCase().endsWith(".pdf");

        // Check if the document is a PDF file
        if (isPDF) {
          const errorMsg = "Cannot export PDF files. Please convert the PDF to a Word document (.docx) first by using 'Save As' in Word, then try again.";
          reject(new Error(errorMsg));
          return;
        }

        // Export document as compressed file
        Office.context.document.getFileAsync(
          Office.FileType.Compressed,
          { sliceSize: 65536 },
          function (result) {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
              const file = result.value;
              let sliceCount = file.sliceCount;
              let slicesReceived = 0;
              let docdataSlices: (ArrayBuffer | Uint8Array)[] = [];

              function getSliceAsync(sliceIndex: number) {
                file.getSliceAsync(sliceIndex, function (sliceResult) {
                  if (
                    sliceResult.status === Office.AsyncResultStatus.Succeeded
                  ) {
                    const sliceData = sliceResult.value.data;

                    docdataSlices[sliceIndex] = sliceData;
                    slicesReceived++;

                    if (slicesReceived === sliceCount) {
                      try {
                        file.closeAsync();

                        const docContent = concatenateSlices(docdataSlices);

                        // Convert to Blob and then to File
                        // Create a proper ArrayBuffer from Uint8Array for blob compatibility
                        const arrayBuffer = docContent.buffer.slice(
                          docContent.byteOffset,
                          docContent.byteOffset + docContent.byteLength
                        ) as ArrayBuffer;
                        const blob = new Blob([arrayBuffer], {
                          type:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        });

                        // Create File object from Blob
                        const fileObj = new File([blob], filename, {
                          type:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          lastModified: Date.now(),
                        });

                        resolve(fileObj);
                      } catch (fileCreationError) {
                        console.error(
                          "Error during file creation:",
                          fileCreationError
                        );
                        reject(fileCreationError);
                      }
                    } else {
                      getSliceAsync(sliceIndex + 1);
                    }
                  } else {
                    console.error(
                      "getSliceAsync Error:",
                      sliceResult.error?.message || "Unknown error"
                    );
                    reject(
                      new Error(
                        sliceResult.error?.message || "Failed to get slice"
                      )
                    );
                  }
                });
              }

              if (sliceCount > 0) {
                getSliceAsync(0);
              } else {
                reject(new Error("Document has no slices"));
              }
            } else {
              const errorCode = result.error?.code;
              const errorMessage = result.error?.message;
              const docUrl = Office.context.document.url || "";

              // Provide a more helpful error message for common issues
              let friendlyMessage = errorMessage || "Unknown error";
              
              if (errorCode === 5001) {
                // Internal error often means unsupported file type or corrupted document
                if (docUrl.toLowerCase().endsWith(".pdf")) {
                  friendlyMessage = "Cannot process PDF files. Please convert to Word format (.docx) using 'Save As' in Word.";
                } else {
                  friendlyMessage = "Unable to export document. The file may be corrupted or in an unsupported format. Try saving it as a new .docx file.";
                }
              }

              reject(new Error(`${friendlyMessage} (Error code: ${errorCode})`));
            }
          }
        );
      } catch (error) {
        console.error("getDocumentAsFile caught error:", error);
        reject(error);
      }
    });
  },

  getDocumentProperties: () => {
    return new Promise((resolve) => {
      Word.run((context) => {
        var customDocProps = context.document.properties.customProperties;
        context.load(customDocProps);
        return context.sync().then(() => {
          let props: any = {};
          for (let item of customDocProps.items) {
            props[item.key] = item.value;
          }
          resolve(props);
          // this.projectNotFound = true;
        });
      });
    });
  },

  // Get current document title/filename
  getDocumentTitle: (): Promise<string> => {
    return new Promise((resolve, _reject) => {
      try {
        // First, try to get filename from URL (works for SharePoint/OneDrive)
        const docUrl = Office.context.document.url;

        if (docUrl) {
          // Extract filename from URL
          const urlParts = docUrl.split("/");
          const filenameWithQuery = urlParts[urlParts.length - 1];
          const filename = filenameWithQuery.split("?")[0];

          if (filename && filename !== "" && filename !== "undefined") {
            resolve(filename);
            return;
          }
        }

        // Fallback: Try to get title from document properties
        Word.run(async (context) => {
          const properties = context.document.properties;
          properties.load("title");

          await context.sync();

          const title = properties.title;

          if (title && title.trim() !== "") {
            resolve(title);
          } else {
            resolve("Document");
          }
        }).catch((error) => {
          console.error("Error getting document title:", error);
          resolve("Document.docx");
        });
      } catch (error) {
        console.error("getDocumentTitle caught error:", error);
        resolve("Document.docx");
      }
    });
  },

  getSelectedText: () => {
    return new Promise((resolve) => {
      Office.context.document.getSelectedDataAsync(
        Office.CoercionType.Text,
        function (asyncResult) {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
            console.error(
              "Action failed. Error: " + asyncResult.error.message,
              asyncResult
            );
          } else {
            resolve(asyncResult.value);
          }
        }
      );
    });
  },

  setSelectedText: (text: string) => {
    return new Promise((resolve) => {
      Office.context.document.setSelectedDataAsync(
        text,
        function (asyncResult) {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
            console.error(
              "Action failed. Error: " + asyncResult.error.message,
              asyncResult
            );
          } else {
            resolve(asyncResult.value);
          }
        }
      );
    });
  },

  stopDocumentSelectionChanged: () => {
    Office.context.document.removeHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      () => {}
    );
  },
};
